// extracted by mini-css-extract-plugin
export default {"container":"sj-z","blurb":"tj-z","links":"uj-z"};